import React, { useEffect, useRef, useState } from 'react'
import { Button, Typography, Input, Divider } from 'antd'
import { FcGoogle } from "react-icons/fc";
import type { InputRef } from "antd";
// import logo from "../../../src/assets/logo.png"
import { Link, useNavigate } from 'react-router-dom';
import { IoMdArrowBack } from "react-icons/io";
import axios from 'axios';
import axiosInstance from '../utils/axiosInterceptor';
import { toast } from 'react-hot-toast';

export const Signup = () => {
    const { Title, Text } = Typography;
    const inputRef = useRef<InputRef>(null)
     const otpRefs = useRef<Array<InputRef | null>>([]);


    useEffect(() => {
        inputRef.current?.input?.focus();
    }, [])



    const navigate = useNavigate();
    const [email, setEmail] = useState<string>("")
    const [password, setPassword] = useState<string>("")
    const [confirmPassword, setConfirmPassword] = useState<string>("")

    const [authError, setAuthError] = useState<string>("")
    const [emailError, setEmailError] = useState<string>("\u200B")
    const [passwordError, setPasswordError] = useState<string>("\u200B")
    const [confirmPasswordError, setConfirmPasswordError] = useState<string>("\u200B")

    const [isInputErrorEmail, setIsInputErrorEmail] = useState<boolean>(false)
    const [isInputErrorPassword, setIsInputErrorPassword] = useState<boolean>(false)
    const [isInputErrorConfirmPassword, setIsInputErrorConfirmPassword] = useState<boolean>(false)
    const [stage, setStage] = useState<number>(1)
     const [otp, setOtp] = useState(["", "", "", "", ""]);
     const [otpError, setOtpError] = useState<string>()
   

    const[isLoading, setIsloading] = useState(false)

    useEffect(() => {
        if (email.trim()) {
            setEmailError("\u200B");
            setIsInputErrorEmail(false);
        }
    }, [email]);

    useEffect(() => {
        if (password.trim()) {
            setPasswordError("\u200B");
            setIsInputErrorPassword(false);
        }
    }, [password]);

    useEffect(() => {
        if (confirmPassword.trim()) {
            setConfirmPasswordError("\u200B");
            setIsInputErrorConfirmPassword(false);
        }
    }, [confirmPassword]);

const handleOtpChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
) => {
    const value = e.target.value;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next input
    if (value && index < 4) {
        otpRefs.current[index + 1]?.focus();
    }

    // Move back on delete
    if (!value && index > 0) {
        otpRefs.current[index - 1]?.focus();
    }
};

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>, stage: number) => {
        try {
            e.preventDefault()
            setIsloading(true)
            
            if(stage === 1){
                // Validate email
                if (!email.trim()) {
                    setEmailError("Email is required");
                    setIsInputErrorEmail(true);
                    setIsloading(false);
                    return;
                }

                // Email format validation
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(email)) {
                    setEmailError("Please enter a valid email address");
                    setIsInputErrorEmail(true);
                    setIsloading(false);
                    return;
                }

                axiosInstance.post(`/auth/register/send-otp`, { email }).then((response:any)=>{
                    setStage(2);
                    setIsloading(false);
                    toast.success("OTP sent to your email");
                }).catch((error:any)=>{
                    toast.error(error.response?.data?.message || "Failed to send OTP");
                    setEmailError(error.response?.data?.message || "Failed to send OTP");
                    setIsInputErrorEmail(true);
                    setIsloading(false);
                });

            }else if(stage === 2){
                const otpValue = otp.join("");

                if(!otpValue){
                    setOtpError("OTP is required");
                    setIsloading(false);
                    return;
                }
                
                if(otpValue.length !== 5){
                    setOtpError("OTP must be 5 digits");
                    setIsloading(false);
                    return;
                }
    
                axiosInstance.post(`/auth/register/verify-otp`, { email, otp: otpValue }).then((response:any)=>{
                    setStage(3);
                    setIsloading(false);
                    toast.success("OTP verified successfully");
                }).catch((error:any)=>{
                    setOtpError(error.response?.data?.error || "Invalid OTP");
                    toast.error(error.response?.data?.error || "Invalid OTP");
                    setIsloading(false);
                });
            }else if(stage === 3){
                // Validate password
                if (!password.trim()) {
                    setPasswordError("Password is required");
                    setIsInputErrorPassword(true);
                    setIsloading(false);
                    return;
                }

                // Password length validation (minimum 6 characters)
                if (password.length < 6) {
                    setPasswordError("Password must be at least 6 characters long");
                    setIsInputErrorPassword(true);
                    setIsloading(false);
                    return;
                }

                // Validate confirm password
                if (!confirmPassword.trim()) {
                    setConfirmPasswordError("Please confirm your password");
                    setIsInputErrorConfirmPassword(true);
                    setIsloading(false);
                    return;
                }

                // Check if passwords match
                if (password !== confirmPassword) {
                    setConfirmPasswordError("Passwords do not match");
                    setIsInputErrorConfirmPassword(true);
                    setIsloading(false);
                    return;
                }

                // Call registration API
                axiosInstance.post(`/auth/register`, { email, password }).then((response:any)=>{
                    if (response.data.success) {
                        toast.success("Account created successfully!");
                        console.log(response.data.data,"response.data");
                        // Store token if provided
                      
                            localStorage.setItem('interview_login_token', response.data.data.token);
                            localStorage.setItem('interview_login_refreshtoken', response.data.data.refreshToken);
                            localStorage.setItem('interview_login_user', JSON.stringify(response.data.data.user));
                        
                        // Navigate to login or dashboard
                        navigate('/dashboard?tab=assessment');
                    }
                    setIsloading(false);
                }).catch((error:any)=>{
                    const errorMessage = error.response?.data?.message || "Registration failed";
                    setAuthError(errorMessage);
                    toast.error(errorMessage);
                    setIsloading(false);
                });
            }

        } catch (error: any) {
            toast.error("Something went wrong. Please try again.");
            setIsloading(false);
        }
    }

    

    function goBackSignup(){
       if(stage === 3 || stage == 2 ){
            setStage(1)
       }
    }

    



    function renderComponents() {
        switch (stage) {
            case 1:
                return (
                    <>
                        <div className="w-full md:w-4/5 flex flex-col gap-px">
                            <Text type="secondary" style={{ marginBottom: "2px" }}>Email</Text>
                            <Input 
                                status={isInputErrorEmail ? "error" : ""} 
                                placeholder="Enter your email"
                                ref={inputRef} 
                                type='email' 
                                value={email} 
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setEmail(e.target.value) }}
                                className="m-0 h-[40px] w-full"
                            />
                            <Text type='danger' style={{ margin: "1px 0", }}>{emailError}</Text>
                        </div>
                        <Button 
                            loading={isLoading} 
                            type='primary' 
                            className="w-full md:w-4/5 mt-1.5" 
                            style={{ marginTop: '5px' }} 
                            htmlType='submit'
                        >
                            Sent OTP
                        </Button>
                    </>
                )

            case 2: 
            return (
                <>
                <div className="w-full md:w-4/5 flex flex-col gap-px">
                    <Text type="secondary" style={{ marginBottom: "2px" }}>Enter OTP</Text>

                    <div className="flex gap-2.5 mt-1 mb-4">
                        {otp.map((digit, index) => (
                            <Input
                                key={index}
                                maxLength={1}
                                autoFocus={index === 0}
                                value={digit}
                                className="!w-[45px] h-[45px] text-center text-xl"
                                status={otpError ? "error" : ""}
                                onChange={(e) => handleOtpChange(e, index)}
                                ref={(el) => { otpRefs.current[index] = el; }}
                            />
                        ))}
                    </div>

                    <Text type="danger" style={{ margin: 0 }}>{otpError}</Text>
                </div>
                 <Button 
                    loading={isLoading} 
                    type='primary' 
                    className="w-full md:w-4/5 mt-1.5" 
                    style={{ marginTop: '5px' }} 
                    htmlType='submit'
                >
                    Verify OTP
                </Button>
                 </>
            )

            case 3:
                return (
                    <>
                        <div className="w-full md:w-4/5 flex flex-col gap-px">
                            <Text type="secondary" style={{ marginBottom: "2px" }}>Password</Text>
                            <Input 
                                status={isInputErrorPassword ? "error" : ""} 
                                placeholder="Enter your password" 
                                type='password' 
                                value={password} 
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setPassword(e.target.value) }}
                                className="m-0 h-[40px] w-full"
                            />
                            <Text type='danger' style={{ margin: 0 }}>{authError || passwordError}</Text>
                        </div>

                        <div className="w-full md:w-4/5 flex flex-col gap-px mt-2">
                            <Text type="secondary" style={{ marginBottom: "2px" }}>Confirm Password</Text>
                            <Input 
                                status={isInputErrorConfirmPassword ? "error" : ""} 
                                placeholder="Confirm your password" 
                                type='password' 
                                value={confirmPassword} 
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setConfirmPassword(e.target.value) }}
                                className="m-0 h-[40px] w-full"
                            />
                            <Text type='danger' style={{ margin: 0 }}>{confirmPasswordError}</Text>
                        </div>
                        <Button 
                            loading={isLoading} 
                            type='primary' 
                            className="w-full md:w-4/5 mt-1.5" 
                            style={{ marginTop: '5px' }} 
                            htmlType='submit'
                        >
                            Create Account
                        </Button>

                    </>
                )


            default:
                break;
        }
    }


    return (
        <div className="w-full min-h-screen flex justify-center items-center p-5">
            <div className="w-full md:w-[60%] max-w-4xl rounded-lg px-2.5 py-6 shadow-md flex flex-col md:flex-row bg-white items-stretch">
                <section className="hidden md:flex w-1/2 flex-col items-center justify-center bg-[#F4F7F9] relative">
                    {/* <ParticleBackground/> */}
                </section>
                <section className="w-full md:w-1/2 flex flex-col items-start md:pl-12 pl-5 pr-5 md:items-start items-center">
                    <div className="mt-8 md:mt-8 mt-5 flex flex-col pb-2.5 w-full pb-4">
                        <img src="https://portal.earlyjobs.ai/logo512.png" height="75px" width="75px" className="md:h-[75px] md:w-[75px] h-[60px] w-[60px]" alt="logo" />
                        <Title level={2}>Let’s Get You Started</Title>
                        <div className="flex gap-4 items-center flex-wrap">
                            {stage > 1 && (
                                <span className="cursor-pointer text-gray-700 hover:text-gray-900 transition-colors inline-flex items-center" onClick={goBackSignup}>
                                    {React.createElement(IoMdArrowBack as any, { className: "h-5 w-5", style: { color: 'inherit' } })}
                                </span>
                            )}
                            <Text>{stage == 1 ? "Enter your Email" : stage == 2 ? `Enter the 5 digit OTP send to ${email}` : ""}</Text>
                        </div>
                        
                    </div>
                    <form className="w-full flex flex-col md:items-start items-center" onSubmit={(e) => handleSubmit(e, stage)}>
                        {renderComponents()}
                       
                        
                        <div className="w-full md:w-4/5 flex items-center mt-4">
                            <Divider className="w-full">
                                <Text type="secondary">OR</Text>
                            </Divider>
                        </div>
                        {/* <Button 
                            icon={<FcGoogle /> as React.ReactElement} 
                            color="default" 
                            variant="outlined" 
                            className="w-4/5 sm:w-full"
                            style={{ width: "80%" }}
                        >
                            Sign up with Google
                        </Button> */}
                    </form>

                    <section className="py-4 w-full md:w-4/5 flex justify-center items-center">
                         <Text>Already have an account? <Link to="/login">Login</Link></Text>
                    </section>    
                </section>
            </div>
        </div>
    )
}
